import React, { useEffect, useState } from "react";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Avatar,
    Pagination,
    Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader/Loading";
import notfound from "../assets/images/not-found.png";
import ViewReportsModal from "../Models/ViewReportsModal";
import { GetReportsList } from "../Redux/Actions/ReportsAction";

const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString())
        return `Today at ${date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
    if (date.toDateString() === yesterday.toDateString())
        return `Yesterday at ${date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;

    return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
};

const Reports = () => {
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [selectedReport, setSelectedReport] = useState(null);

    const rowsPerPage = 10;
    const { reports, loading } = useSelector((state) => state.Reports);

    useEffect(() => {
        dispatch(GetReportsList(page));
    }, [dispatch, page]);

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };
    

    return (
        <>
            <Box sx={{ padding: 2 }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "flex-start", md: "center" },
                        mb: 2,
                        gap: 1,
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: "bold",
                            color: "#424242",
                        }}
                    >
                        Reported Content
                    </Typography>
                </Box>

                <div className="w-full overflow-x-auto z-[0]">
                    <Paper sx={{ height: "auto", background: "transparent" }}>
                        <TableContainer sx={{ minHeight: "78vh", align: "center" }} className="relative">
                            <Table aria-label="sticky table">
                                <TableHead>
                                    <TableRow className="!font-bold">
                                        <TableCell align="left" className="!font-semibold" sx={{ padding: "12px" }}>
                                            Reported By
                                        </TableCell>
                                        <TableCell align="left" className="!font-semibold" sx={{ padding: "12px" }}>
                                            Reported At
                                        </TableCell>
                                        <TableCell align="left" className="!font-semibold" sx={{ padding: "12px" }}>
                                            Action
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {loading ? (
                                        <Loader />
                                    ) : reports?.data?.length > 0 ? (
                                        reports.data.map((report) => (
                                            <TableRow key={report.id}>
                                                <TableCell align="left" sx={{ padding: "12px" }}>
                                                    <div className="flex items-center gap-2">
                                                        <Avatar src={report?.User?.profileImage} />
                                                        <span className="text-nowrap">
                                                            {report?.User?.first_name} {report?.User?.last_name}
                                                        </span>
                                                    </div>
                                                </TableCell>

                                                <TableCell align="left" sx={{ padding: "12px" }}>
                                                    <span>{formatDate(report?.createdAt)}</span>
                                                </TableCell>

                                                <TableCell align="left" sx={{ padding: "12px" }}>
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        onClick={() => setSelectedReport(report)}
                                                        sx={{
                                                            backgroundColor: "#EF5A24",
                                                            color: "white",
                                                            textTransform: "none",
                                                            "&:hover": {
                                                                backgroundColor: "#F38157"
                                                            }
                                                        }}
                                                    >
                                                        View
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={3}>
                                                <div className="flex flex-col justify-center items-center w-full h-[60vh]">
                                                    <img src={notfound} alt="Not Found" style={{ width: "200px" }} />
                                                    <span className="text-xl font-bold mt-6">No reports found</span>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <div className="flex justify-end pt-3">
                            <Pagination
                                shape="rounded"
                                count={Math.ceil(reports?.pagination?.totalRecords / rowsPerPage)}
                                page={page}
                                onChange={handlePageChange}
                                sx={{
                                    "& .MuiPaginationItem-root.Mui-selected": {
                                        background: "linear-gradient(to right, #EF5A24, #F38157)",
                                        color: "#fff",
                                    },
                                    "@media (max-width: 960px)": {
                                        fontSize: "0.75rem",
                                        "& .MuiPaginationItem-root": {
                                            minWidth: "auto",
                                            padding: "8px",
                                            margin: "2px",
                                        },
                                    },
                                    "@media (max-width: 600px)": {
                                        fontSize: "0.5rem",
                                        "& .MuiPaginationItem-root": {
                                            padding: "8px",
                                            margin: "1px",
                                        },
                                    },
                                }}
                            />
                        </div>
                    </Paper>
                </div>
            </Box>
            
            {selectedReport && (
                <ViewReportsModal
                    open={Boolean(selectedReport)}
                    onClose={() => setSelectedReport(null)}
                    report={selectedReport}
                />
            )}
        </>
    );
};

export default Reports;